import { Link } from "react-router-dom"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/users/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "@/pages/users/Model"
import { useState } from "react"
import { CrudProvider } from "@/context/crudContext"
import { useNavigate } from "react-router-dom"
import { isAdminPortal } from "@/utilities/domain"

export default function UserList() {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Users</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/pos/dashboard">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Users</li>
        </ul>
      </div>

      <CrudProvider>
        <UserTable />
      </CrudProvider>
    </>
  )
}

function UserTable() {
  const navigate = useNavigate()
  // Roles are shown on the branch (POS) portal only
  const tableColumns = isAdminPortal()
    ? columns.filter((column) => column.id !== "roles")
    : columns

  return (
    <>
      <CustomTable
        label="Users"
        columns={tableColumns}
        apiPath="user"
        onView={(user) => navigate(`/pos/user/${user.id}`)}
      />

      <Modal />
    </>
  )
}
